import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

const StudentBookingPage = () => {
  const [type, setType] = useState('hostel');
  const [date, setDate] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleBooking = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const token = localStorage.getItem('token');
      const payload = {
        booking_type: type, // make sure this matches your serializer
        booking_date: date
      };

      const url =
        type === 'hostel'
          ? `${API}hostel/bookings/`
          : `${API}library/bookings/`;

      await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setMessage('✅ Booking request submitted!');
    } catch (err) {
      setError('❌ Failed to submit booking.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '500px', margin: '60px auto', textAlign: 'center' }}>
      <h2>Book Your Seat</h2>
      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <form onSubmit={handleBooking}>
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          style={{ padding: '10px', width: '100%', marginBottom: '10px' }}
        >
          <option value="hostel">Hostel Bed</option>
          <option value="library">Library Seat</option>
        </select>

        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
          style={{ padding: '10px', width: '100%', marginBottom: '10px' }}
        />

        <button type="submit" style={{ padding: '10px 20px', width: '100%' }}>
          {loading ? 'Booking...' : 'Submit Booking'}
        </button>
      </form>
    </div>
  );
};

export default StudentBookingPage;
